export default 240



// WEBPACK FOOTER //
// ./src/drawerWidth.js